import axios from '@/api/config';

const chapter = {
  getChapterById(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapter/` + data, {});
  },
  getChapter(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapter`, { params: data });
  },
  chapterKnowledgeList(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/chapterKnowledgeList`, { params: data });
  },
  getKnowledgeSelectListByCourse(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getKnowledgeSelectListByCourse`, { params: data });
  },
  getChapterList(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterList`, { params: data });
  },
  getChapterSelectListByCourse(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterSelectListByCourse`, { params: data });
  },
  getChapterTree(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterTree`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/pageList`, data);
  },
  deleteChapterKnowledge(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/deleteChapterKnowledge`, data);
  },
  addChapterKnowledge(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/addChapterKnowledge`, data);
  },
  updateChapterKnowledge(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/updateChapterKnowledge`, data);
  },
  addChapter(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/addChapter`, data);
  },
  updateChapterVideo(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/updateChapterVideo`, data);
  },
  updateChapter(data) {
    return axios.put(`${process.env.BASE_URL}/chapter/updateChapter`, data);
  },
  deleteChapter(data) {
    return axios.delete(`${process.env.BASE_URL}/chapter/deleteChapter`, { data: data });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/exportExcel`, { params: data });
  },
  chapterVideoList(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/chapterVideoList`, { params: data });
  },
  getFatherChapterList(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getFatherChapterList`, { params: data });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/importData`, data);
  },
  updateChapter(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/updateChapter`, data);
  },
  chapterAttachment(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/chapterAttachment`, data);
  },
  getQuestionByChapter(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getQuestionByChapter`, { params: data });
  },
  getChapterInfo(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterInfo`, { params: data });
  },
  chapterMaterialsList(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/chapterMaterialsList`, { params: data });
  },
  deleteChapterAttachment(data) {
    return axios.post(`${process.env.BASE_URL}/chapter/deleteChapterAttachment`, data);
  },
  getChapterListVideoByPid(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterListVideoByPid`, { params: data });
  },
  getChapterAndKnowledgeSelectListByCourse(data) {
    return axios.get(`${process.env.BASE_URL}/chapter/getChapterAndKnowledgeSelectListByCourse`, { params: data });
  },
}

export default chapter;



// WEBPACK FOOTER //
// ./src/api/chapter.js